import React, { Component, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import dayjs from 'dayjs'

export default function ElecUnitBiomass({ valueElectricGen }) {
  const [tickAmount, setTickAmount] = useState(valueElectricGen?.length)
  const [valueFormat, setValueFormat] = useState('DD MMM')
  console.log('value Electricc gen', valueElectricGen)
  const series = [
    {
      name: 'ปริมาณไฟฟ้าที่ผลิตได้',
      type: 'column',
      data: valueElectricGen,
    },
  ]
  const options = {
    chart: {
      height: 350,
      type: 'line',
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },

    xaxis: {
      type: 'datetime',
      labels: {
        formatter: (value) => dayjs(value).locale('th').format(valueFormat),
      },
      tickAmount,
    },
    yaxis: [
      {
        title: {
          text: 'ปริมาณไฟฟ้าที่ผลิตได้',
        },
      },
    ],
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  )
}
